import { Suspense } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function GizlilikPage() {
  return (
    <Suspense fallback={<div>Yükleniyor...</div>}>
      <div className="min-h-screen bg-gradient-to-b from-white via-primary-light/10 to-white">
        <Navbar />
        
        {/* Hero Section */}
        <section className="pt-32 pb-16 px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="font-serif text-4xl md:text-5xl font-bold text-primary-dark mb-4">
              Gizlilik Politikası
            </h1>
            <p className="text-lg text-gray-600">
              Son Güncelleme: {new Date().toLocaleDateString('tr-TR', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>
        </section>

        {/* Content Section */}
        <section className="pb-20 px-6">
          <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-lg p-8 md:p-12">
            
            <div className="space-y-8">
              {/* Section 1 */}
              <div>
                <h2 className="font-serif text-2xl font-bold text-primary-dark mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gold rounded-full mr-3"></span>
                  1. Giriş
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  Deniz Erin olarak, kişisel verilerinizin güvenliğini ve gizliliğini en üst düzeyde korumayı taahhüt ediyoruz. Bu Gizlilik Politikası, web sitemizi ziyaret ettiğinizde ve hizmetlerimizi kullandığınızda kişisel bilgilerinizin nasıl toplandığını, kullanıldığını, saklandığını ve korunduğunu açıklamaktadır.
                </p>
              </div>

              {/* Section 2 */}
              <div>
                <h2 className="font-serif text-2xl font-bold text-primary-dark mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gold rounded-full mr-3"></span>
                  2. Toplanan Bilgiler
                </h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  Hizmetlerimizi sunabilmek için aşağıdaki bilgileri toplayabiliriz:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li><strong>Kimlik Bilgileri:</strong> Ad, soyad, doğum tarihi, doğum yeri ve saati</li>
                  <li><strong>İletişim Bilgileri:</strong> E-posta adresi, telefon numarası</li>
                  <li><strong>Ödeme Bilgileri:</strong> Fatura bilgileri (ödeme işlemleri güvenli üçüncü taraf sistemler üzerinden yapılır)</li>
                  <li><strong>Seans Bilgileri:</strong> Danışmanlık seanslarında paylaştığınız kişisel bilgiler ve notlar</li>
                  <li><strong>Teknik Bilgiler:</strong> IP adresi, tarayıcı türü, cihaz bilgileri, çerezler</li>
                </ul>
              </div>

              {/* Section 3 */}
              <div>
                <h2 className="font-serif text-2xl font-bold text-primary-dark mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gold rounded-full mr-3"></span>
                  3. Bilgilerin Kullanım Amaçları
                </h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  Topladığımız kişisel veriler aşağıdaki amaçlarla kullanılmaktadır:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>Astrolojik danışmanlık, spiritüel danışmanlık ve şifa hizmetlerinin sunulması</li>
                  <li>Randevu oluşturma, yönetme ve hatırlatma bildirimleri gönderme</li>
                  <li>Doğum haritası analizi ve kişisel raporların hazırlanması</li>
                  <li>Müşteri destek hizmetlerinin sağlanması</li>
                  <li>Ödeme işlemlerinin gerçekleştirilmesi</li>
                  <li>Yasal yükümlülüklerin yerine getirilmesi</li>
                  <li>Hizmet kalitesinin iyileştirilmesi ve müşteri memnuniyetinin artırılması</li>
                  <li>İzniniz dahilinde, yeni hizmetler ve kampanyalar hakkında bilgilendirme</li>
                </ul>
              </div>

              {/* Section 4 */}
              <div>
                <h2 className="font-serif text-2xl font-bold text-primary-dark mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gold rounded-full mr-3"></span>
                  4. Bilgilerin Paylaşımı
                </h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  Kişisel bilgileriniz, aşağıdaki durumlar dışında üçüncü taraflarla paylaşılmaz:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>Açık rızanızın bulunması durumunda</li>
                  <li>Yasal zorunluluklar ve mahkeme kararları gereği</li>
                  <li>Ödeme işlemlerinin gerçekleştirilmesi için güvenli ödeme sağlayıcılarıyla</li>
                  <li>Hizmet sağlayıcılar (hosting, e-posta servisleri) ile sınırlı ve gerekli ölçüde</li>
                </ul>
                <p className="text-gray-700 leading-relaxed mt-3">
                  Üçüncü taraf hizmet sağlayıcılar, verilerinizi yalnızca bizim talimatlarımız doğrultusunda işler ve gizlilik yükümlülüklerine tabidir.
                </p>
              </div>

              {/* Section 5 */}
              <div>
                <h2 className="font-serif text-2xl font-bold text-primary-dark mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gold rounded-full mr-3"></span>
                  5. Veri Güvenliği
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  Kişisel verilerinizin güvenliğini sağlamak için endüstri standardı güvenlik önlemleri alıyoruz. Verileriniz şifreli bağlantılar (SSL/TLS) üzerinden iletilir ve güvenli sunucularda saklanır. Yetkisiz erişim, değişiklik, ifşa veya imha edilmeye karşı teknik ve idari önlemler uygulanmaktadır.
                </p>
              </div>

              {/* Section 6 */}
              <div>
                <h2 className="font-serif text-2xl font-bold text-primary-dark mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gold rounded-full mr-3"></span>
                  6. Çerezler (Cookies)
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  Web sitemiz, kullanıcı deneyimini iyileştirmek ve site trafiğini analiz etmek için çerezler kullanmaktadır. Çerezler, tarayıcınız tarafından cihazınızda saklanan küçük metin dosyalarıdır. Tarayıcı ayarlarınızdan çerezleri yönetebilir veya reddedebilirsiniz, ancak bu durumda bazı site özelliklerinin düzgün çalışmaması mümkündür.
                </p>
              </div>

              {/* Section 7 */}
              <div>
                <h2 className="font-serif text-2xl font-bold text-primary-dark mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gold rounded-full mr-3"></span>
                  7. Haklarınız
                </h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  KVKK kapsamında aşağıdaki haklara sahipsiniz:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
                  <li>İşlenmişse buna ilişkin bilgi talep etme</li>
                  <li>İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme</li>
                  <li>Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme</li>
                  <li>Eksik veya yanlış işlenmişse düzeltilmesini isteme</li>
                  <li>Verilerin silinmesini veya yok edilmesini talep etme</li>
                  <li>İşlenen verilerin münhasıran otomatik sistemler ile analiz edilmesi nedeniyle aleyhinize bir sonuç doğması halinde itiraz etme</li>
                </ul>
              </div>

              {/* Section 8 */}
              <div>
                <h2 className="font-serif text-2xl font-bold text-primary-dark mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gold rounded-full mr-3"></span>
                  8. Veri Saklama Süresi
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  Kişisel verileriniz, işlenme amaçları doğrultusunda gerekli olan süre boyunca ve yasal saklama yükümlülüklerine uygun olarak saklanır. Amaç ortadan kalktığında veya yasal saklama süresi sona erdiğinde verileriniz silinir, yok edilir veya anonim hale getirilir.
                </p>
              </div>

              {/* Section 9 */}
              <div>
                <h2 className="font-serif text-2xl font-bold text-primary-dark mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gold rounded-full mr-3"></span>
                  9. Değişiklikler
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  Bu Gizlilik Politikası, yasal düzenlemeler veya hizmetlerimizdeki değişiklikler doğrultusunda güncellenebilir. Önemli değişiklikler olması durumunda, web sitemiz üzerinden veya e-posta yoluyla bilgilendirileceksiniz. Güncel politikayı düzenli olarak kontrol etmenizi öneririz.
                </p>
              </div>

              {/* Section 10 */}
              <div>
                <h2 className="font-serif text-2xl font-bold text-primary-dark mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gold rounded-full mr-3"></span>
                  10. İletişim
                </h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  Gizlilik politikamız hakkında sorularınız veya talepleriniz için bizimle iletişime geçebilirsiniz:
                </p>
                <div className="bg-primary-light/20 rounded-2xl p-6 space-y-2">
                  <p className="text-gray-700"><strong>E-posta:</strong> info@denizerin.com</p>
                  <p className="text-gray-700"><strong>Telefon:</strong> +90 XXX XXX XX XX</p>
                  <p className="text-gray-700"><strong>Adres:</strong> [Adres Bilgisi]</p>
                </div>
              </div>

              {/* Important Notice */}
              <div className="bg-gold/10 border-l-4 border-gold rounded-lg p-6 mt-8">
                <p className="text-sm text-gray-700 leading-relaxed">
                  <strong className="text-primary-dark">Önemli Uyarı:</strong> Sunulan hizmetler tıbbi, psikolojik veya hukuki danışmanlık yerine geçmez. Astrolojik ve spiritüel danışmanlık hizmetleri, kişisel gelişim ve farkındalık amaçlıdır.
                </p>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </Suspense>
  );
}